import * as FilterExtensionActions from '../actions/filter-extensions.actions'
import { FilterExtensionsState, initalGridFilterExtensionsState } from '../models/filter-extensions.model';

export function gridFilterExtensionReducer(state: FilterExtensionsState = initalGridFilterExtensionsState, action: FilterExtensionActions.Actions) {
  switch (action.type) {
    case FilterExtensionActions.UPDATE_FUZZY_SEARCH:
      if (action.payload != state.fuzzySearch) {
        return {
          ...state,
          fuzzySearch: action.payload
        };
      }
      return state;
    default:
      return state;
  }
}
